import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppBar } from './AppBar';
import { AIAssistantFab } from './AIAssistantFab';
import { AIAssistantDrawer } from './AIAssistantDrawer';

export function AppLayout() {
  const [aiOpen, setAiOpen] = useState(false);
  const location = useLocation();

  // Drawer is opt-in: close on every route change so it never carries over
  // automatically when the clinician moves to a different patient or section.
  useEffect(() => {
    setAiOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen">
      <AppBar />
      <Outlet />
      <AIAssistantFab onClick={() => setAiOpen(true)} />
      <AIAssistantDrawer open={aiOpen} onClose={() => setAiOpen(false)} />
    </div>
  );
}
